<!-- eslint-disable no-unused-vars -->
<template>
  <v-data-table
    :headers="serviceHeaders"
    :items="dataservice"
    :single-expand="singleExpand"
    :expanded.sync="expanded"
    :search="searchservice"
    item-key="id_service"
    show-expand
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar
        flat
        class="mt-5"
      >
        <v-toolbar-title>Data Service Hotel {{ hotel.hotel_name }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="searchservice"
          solo
          dense
          append-icon="mdi-magnify"
          :label="'Search Service '+hotel.hotel_name"
          class="mr-3 white"
          outlined
          hide-details
        ></v-text-field>
      </v-toolbar>
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        <v-row>
          <v-col
            cols="12"
            md="5"
          >
            <v-simple-table>
              <tbody>
                <tr>
                  <td>Rates</td>
                  <td> : Rp. {{ Number(item.rates).toLocaleString() }}</td>
                </tr>
                <tr>
                  <td>Extra Bed</td>
                  <td> : Rp. {{ Number(item.exbed).toLocaleString() }}</td>
                </tr>
                <tr>
                  <td>Child with Bed</td>
                  <td> : Rp. {{ Number(item.cob).toLocaleString() }}</td>
                </tr>
                <tr>
                  <td>Child No Bed</td>
                  <td> : Rp. {{ Number(item.cwob).toLocaleString() }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
          <v-col>
            <v-simple-table>
              <tbody>
                <tr>
                  <td>Notes</td>
                  <td>{{ item.notes }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
      </td>
    </template>
    <template #[`item.validity_period`]="{ item }">
      <v-chip
        :color="getColor(item.end_date,item.start_date)"
        dark
        v-text="CountContract(item.end_date,item.start_date)"
      >
      </v-chip>
    </template>
    <template #[`item.actions`]="{ item }">
      <v-btn
        small
        class="mr-2 text-capitalize primary"
        @click="UseService(item)"
      >
        Use Service
        <v-icon>{{ icons.mdiPlus }}</v-icon>
      </v-btn>
    </template>
    <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="initialize"
      >
        Reset
      </v-btn>
    </template>
  </v-data-table>
</template>
<script>
import {
  mdiPencil,
  mdiTrashCan,
  mdiPlus,
  mdiClose,
} from '@mdi/js'
import axios from 'axios'

export default {
  props: ['hotel', 'date'],
  data() {
    return {
      icons: {
        mdiPencil,
        mdiTrashCan,
        mdiPlus,
        mdiClose,
      },
      modal1: false,
      modal2: false,
      dialog: false,
      dialog3: false,
      searchservice: '',
      expanded: [],
      editedIndex: -1,
      singleExpand: true,
      serviceHeaders: [
        { text: 'Type Room', value: 'type_room' },
        { text: 'Periode', value: 'periode' },
        { text: 'Start Date', value: 'start' },
        { text: 'End Date', value: 'end' },
        { text: 'Validity Period', value: 'validity_period' },
        {
          text: 'Actions', value: 'actions', sortable: false, width: 200,
        },
      ],
      formservice: {
        id_service: '',
        id_hotel: this.hotel.id_hotel,
        type_room: '',
        periode: '',
        start_date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        end_date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        rates: '',
        exbed: '',
        cob: '',
        cwob: '',
        notes: '',
      },
      dataservice: [],
      choosebed: '',
      choosed: {},
      datenow: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Add New Service Hotel' : 'Edit Service Hotel'
    },
    TittleButton() {
      return this.editedIndex === -1 ? 'Save Hotel' : 'Update Hotel'
    },
  },
  watch: {
    hotel(newVal, oldVal) {
      if (newVal.id_hotel !== oldVal.id_hotel) {
        this.initialize()
      }
    },
    date(newVal, oldVal) {
      this.datenow = newVal
    },
  },
  mounted() {
    this.initialize()
    this.datenow = this.date
  },
  methods: {
    getColor(end, start) {
      if (this.datenow < start) {
        return 'warning'
      } if (this.datenow > end) {
        return 'error'
      }

      return 'primary'
    },
    CountContract(end, start) {
      if (this.datenow < start) {
        return 'Valid Soon'
      } if (this.datenow > end) {
        return 'Expired'
      }

      return 'Valid'
    },
    UseService(item) {
      this.$root.$emit('MakeHotel', item)
    },
    CekDialog() {
      this.formservice = {
        id_service: '',
        id_hotel: this.hotel.id_hotel,
        type_room: '',
        periode: '',
        start_date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        end_date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        rates: '',
        exbed: '',
        cob: '',
        cwob: '',
        notes: '',
      }
      this.dialog3 = false
    },
    editItem(item) {
      this.editedIndex = this.dataservice.indexOf(item)
      this.formservice = item
      this.dialog3 = true
    },
    initialize() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/getServiceHotel', { id_hotel: this.hotel.id_hotel }).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.dataservice = response.data.data
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
    deleteItem(item) {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/DeleteServiceHotel', item).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.initialize()
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
    Save() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/SaveServiceHotel', this.formservice).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.dialog3 = false
        this.CekDialog()
        this.editedIndex = -1
        this.initialize()
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
  },
}
</script>
